"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var service_service_1 = require("../../Services/service.service");
var searchroute_service_1 = require("../../Services/searchroute.service");
var platform_browser_1 = require("@angular/platform-browser");
var SeoTextsWrapperComponent = /** @class */ (function () {
    function SeoTextsWrapperComponent(route, service, searchRouteService, activatedRoute, _sanitizer) {
        var _this = this;
        this.route = route;
        this.service = service;
        this.searchRouteService = searchRouteService;
        this.activatedRoute = activatedRoute;
        this._sanitizer = _sanitizer;
        this.seoUrlMap = window["seoUrlMap"];
        this.seoWrapper = document.getElementById("staticSeoText");
        this.currentUrl = "";
        this.curentCategoryId = 0;
        this.casualDating = false;
        this.currentCityId = 0;
        this.route.events.subscribe(function (event) {
            if (event instanceof router_1.NavigationStart) {
                _this.currentUrl = event.url;
                _this.setSEOView(_this.currentUrl);
                //this.seoWrapper.style.display = "none";
                if (_this.seoWrapper) {
                    _this.seoWrapper.remove();
                }
            }
        });
        // this.service.advService.resultListUpdate.subscribe(r => {
        //   console.log("result list update");
        //   this.setSEOView(this.currentUrl);
        //   seoWrapper.remove();
        // });
    }
    SeoTextsWrapperComponent.prototype.ngOnInit = function () {
    };
    SeoTextsWrapperComponent.prototype.setSEOView = function (curentUrl) {
        var slicedUrl = curentUrl.slice(1);
        if (this.seoUrlMap) {
            if (this.currentUrl == "/") {
                this.currentItem = this.seoUrlMap.texts[1].text;
                //this.seoWrapper.innerHTML = this.seoUrlMap.texts[1].text;
            }
            else if (this.seoUrlMap.urls[slicedUrl]) {
                var seoTextId = this.seoUrlMap.urls[slicedUrl];
                this.currentItem = this.seoUrlMap.texts[seoTextId].text;
                //this.seoWrapper.innerHTML = this.seoUrlMap.texts[seoTextId].text;
            }
            else {
                this.currentItem = "";
            }
        }
    };
    return SeoTextsWrapperComponent;
}());
exports.SeoTextsWrapperComponent = SeoTextsWrapperComponent;
